const config = {
  apiUrl: 'https://ro-services-mu.vercel.app/',
};

export default config;
